import { Stack, Typography } from '@mui/material';
import type { FC } from 'react';
import { useState } from 'react';
import { ReportFormDispatchedProducts } from '~/components/organisms/ReportFormDispatchedProducts';
import { ReportOptions } from '~/components/organisms/ReportOptions';
import { ReportsBanner } from '~/components/organisms/ReportsBanner';
import type { ReportOption } from '~/types/Reports';

/*
  We don't know what types of reports will be needed in the future, so each "form" that generates a report should be a separate component.
  This way, we can easily add new report options with any form fields or configurations needed.
  Each report option should have an id, title, description, and the component that generates the report.
*/
const REPORT_OPTIONS: ReportOption[] = [
  {
    id: 1,
    title: 'Dispatch Order Report',
    description: 'Generate a report of all dispatched orders',
    component: ReportFormDispatchedProducts
  }
  // TODO: As more report options are added, add them here (may need to also update the ReportsOptions component grid styling depending on the number of options)
];

export const Reports: FC = () => {
  const [selectedOption, setSelectedOption] = useState<ReportOption['id']>(REPORT_OPTIONS[0].id);

  const activeReport = REPORT_OPTIONS.find((option) => option.id === selectedOption);
  const ActiveReportComponent = activeReport?.component;

  return (
    <>
      <ReportsBanner />

      <Stack component="section" spacing={{ xs: 3, md: 5 }} pt={{ xs: 5.75, md: 7.75 }} pb={7.75} alignItems="center">
        <Stack spacing={2} maxWidth={752} mx="auto" px={{ xs: 3, lg: 0 }} textAlign="center">
          <Typography component="h1" variant="h4" fontWeight={700}>
            Generate a report
          </Typography>

          <Typography component="p" variant="body1" color="text.secondary">
            Select your desired report, configure the options, click &quot;Generate&quot; and the report will be created
            and <strong>sent to your email.</strong>
          </Typography>
        </Stack>

        <ReportOptions
          options={REPORT_OPTIONS}
          selectedOption={selectedOption}
          handleOptionSelect={setSelectedOption}
        />
      </Stack>

      {ActiveReportComponent && <ActiveReportComponent />}
    </>
  );
};
